import { GTM_PRICE_PER_EMAIL_USD } from './gtm-pricing'
import type { GtmFunnelEstimate } from '@laplace/contracts'

/** B2B email benchmarks; keep in sync with the API's GTM_BENCHMARK_*. */
const POSITIVE_REPLY_RATE = { min: 0.003, max: 0.005 }
const MEETING_RATE = { min: 0.5, max: 0.65 }

/**
 * The landing's estimate for a budget: the same math as the API's
 * buildGtmFunnelEstimate. Lower bounds round down and upper bounds round
 * up, so the page never promises more than the benchmark supports.
 */
export function buildGtmFunnelEstimate(budgetUsd: number): GtmFunnelEstimate {
  const emails = Math.floor(budgetUsd / GTM_PRICE_PER_EMAIL_USD)
  const meetings = {
    min: Math.floor(emails * POSITIVE_REPLY_RATE.min * MEETING_RATE.min),
    max: Math.ceil(emails * POSITIVE_REPLY_RATE.max * MEETING_RATE.max),
  }
  const perMeeting = (count: number) =>
    count > 0 ? Math.round((budgetUsd / count) * 100) / 100 : budgetUsd

  return {
    basis: 'industry_benchmark',
    pricePerEmailUsd: GTM_PRICE_PER_EMAIL_USD,
    positiveReplyRate: { ...POSITIVE_REPLY_RATE },
    meetingRate: { ...MEETING_RATE },
    example: {
      budgetUsd,
      emails,
      positiveReplies: {
        min: Math.floor(emails * POSITIVE_REPLY_RATE.min),
        max: Math.ceil(emails * POSITIVE_REPLY_RATE.max),
      },
      meetings,
      costPerMeetingUsd: {
        min: perMeeting(meetings.max),
        max: perMeeting(Math.max(meetings.min, 1)),
      },
    },
  }
}
